import { AuthenticationService } from './Authentication';

export function HandleResponse(response) {
    return response.text().then(text => {
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                AuthenticationService.logout();
                // window.location.reload(true);
            }

            AuthenticationService.logout(); // added by me
            // const error = (data && data.message) || response.statusText;
            return Promise.reject(text);
        }

        return text && JSON.parse(text);
    });
}

export function HandleResponseNoLogout(response) {
    return response.text().then(text => {
        if (!response.ok) {
            return Promise.reject(text);
        }

        return text && JSON.parse(text);
    });
}